<template>
  <div class="mit-return-key-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Return Keys</v-card-title>
            <v-card-subtitle class="caption">Return borrowed keys</v-card-subtitle>

            <v-divider></v-divider>
            <v-stepper v-if="!wizard.complete" v-model="wizard.step" alt-labels>
              <v-stepper-header>
                <v-stepper-step :complete="wizard.step > 1" step="1">Select User</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="wizard.step > 2" step="2">Returned Keys</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3">Review</v-stepper-step>
              </v-stepper-header>
              <v-divider></v-divider>
              <v-stepper-items>
                <v-stepper-content step="1">
                    <v-container>
                      <v-form ref="formUser" lazy-validation>
                        <v-autocomplete
                          color="primary"
                          label="Select User"
                          v-model="wizard.formData.selectedUser"
                          :items="userList"
                          :search-input.sync="userSearch"
                          :loading="wizard.formData.usersloading"
                          item-text="id"
                          return-object
                          no-data-text="Enter text to get users..."
                          outlined
                          v-on:change="userSelectedEvent"
                        >
                            <template v-slot:item="data">
                                <v-list-item-content>
                                  <v-list-item-title>{{data.item.id}}</v-list-item-title>
                                  <v-list-item-subtitle>{{data.item.email}}</v-list-item-subtitle>
                                  <v-list-item-subtitle>{{data.item.name}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                      </v-form>
                    </v-container>
                  <div class="wizard-actions">
                    <v-btn disabled>Back</v-btn>
                    <v-btn :disabled="wizard.formData.selectedUser == ''" class="ml-3" color="primary" @click="wizard.step = 2">Next</v-btn>
                  </div>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <v-container>
                      <v-form ref="formKeys">
                        <v-row justify="space-between">
                          <v-col cols="12" md="5">
                              <p>User's Keys</p>
                              <v-divider></v-divider>
                              <v-list dense style="max-height: 200px" class="overflow-y-auto">
                                <!-- <v-subheader>Selected Keys</v-subheader> -->
                                <v-list-item-group v-model="wizard.formData.selectedBorrowedList" color="primary">
                                  <v-list-item v-for="(item, i) in wizard.formData.borrowedList" :key="i">
                                    <v-list-item-icon>
                                      <v-icon>mdi-key</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title>{{item.keyName}}</v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                          </v-col>

                          <v-col cols="12" md="2">
                              <v-row class="pb-10 pt-15" align="center" justify="center">
                                <v-btn :disabled="wizard.formData.selectedBorrowedList == null" @click="addToReturnedKeys"><v-icon>mdi-arrow-right-bold</v-icon></v-btn><br>
                              </v-row>
                              <v-row align="center" justify="center">
                                <v-btn :disabled="wizard.formData.selectedReturnList == null" @click="removeFromReturnedKeys"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
                              </v-row>
                          </v-col>

                          <v-col cols="12" md="5">
                              <p>Returned Keys</p>
                              <v-divider></v-divider>
                              <v-list dense style="max-height: 200px" class="overflow-y-auto">
                                <v-list-item-group v-if="wizard.formData.returnList.length == 0" color="primary">
                                  <v-list-item>
                                    <p style="color:gray;">(None)</p>
                                  </v-list-item>
                                </v-list-item-group>

                                <v-list-item-group v-model="wizard.formData.selectedReturnList" color="primary">
                                  <div v-for="(item, i) in wizard.formData.returnList" :key="i">
                                    <v-list-item v-if="item.hide != true && item.selected != true" >
                                      <v-list-item-icon>
                                        <v-icon>mdi-key</v-icon>
                                      </v-list-item-icon>
                                      <v-list-item-content>
                                        <v-list-item-title>{{item.keyName}}</v-list-item-title>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </div>
                                </v-list-item-group>
                              </v-list>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>

                    <div class="wizard-actions">
                      <v-btn @click="wizard.step = 1">Back</v-btn>
                      <v-btn :disabled="wizard.formData.returnList.length <= 0" class="ml-3" color="primary" @click="wizard.step = 3">Next</v-btn>
                    </div>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-card class="mb-12"elevation="0">
                    <v-card-title>
                      Review
                    </v-card-title>
                    <v-card-text>
                      <h3>User</h3>
                      <v-divider></v-divider>
                      <v-row justify="space-between" v-if="wizard.formData.selectedUser">
                        <v-col col="1" md="1">
                          <v-icon x-large>mdi-account</v-icon>
                        </v-col>
                        <v-col col="11" md="11">
                          <div><h4>{{wizard.formData.selectedUser.id}}</h4></div>
                          <div>{{wizard.formData.selectedUser.email}}</div>
                          <div>{{wizard.formData.selectedUser.name}}</div>
                        </v-col>
                      </v-row>
                      <h3>Keys Returned</h3>
                      <v-divider></v-divider>

                      <v-row justify="space-between">
                        <v-col col="1" md="1">
                          <v-icon x-large>mdi-key-chain</v-icon>
                        </v-col>
                        <v-col col="11" md="11">
                          <v-list dense>
                            <v-list-item-group color="primary">
                              <v-list-item v-for="(item, i) in wizard.formData.returnList" :key="i">
                                <v-list-item-icon>
                                  <v-icon>mdi-key</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title><h4>{{item.keyName}}</h4></v-list-item-title>
                                  <div>Space(s):
                                    <MitKeySpaces :dark="false" size="small" :spaces="item.spacesDisplay" :spacesDetails="item.spaces"/>
                                  </div>
                                  <div>Notes: {{item.data.notes}}</div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <div class="wizard-actions">
                    <v-btn @click="wizard.step = 2">Back</v-btn>
                    <v-btn class="ml-3" color="primary" @click="wizardComplete">Finish</v-btn>
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
            <v-card v-if="wizard.complete">
                <div v-if="wizard.loading">
                  <v-card-title>Loading...</v-card-title>
                  <v-card-text>
                      <v-col v-if="wizard.loading" class="d-flex justify-center align-center">
                        <v-row>
                          <MitLoading class="pa-10"/>
                        </v-row>
                      </v-col>
                  </v-card-text>
                </div>
                <div v-if="!wizard.loading && wizard.result.success">
                  <v-card-title><v-icon class="pr-5" color="success" x-large>mdi-check-circle</v-icon>Success</v-card-title>
                  <v-card-text>
                      Successfully checked out keys.
                  </v-card-text>
                </div>
                <div v-if="!wizard.loading && !wizard.result.success">
                  <v-card-title><v-icon color="error" x-large>mdi-alert-circle</v-icon>Error</v-card-title>
                  <v-card-text>
                    Sorry, an error occurred trying to borrow keys.
                  </v-card-text>
                  <div class="pb-10"> {{wizard.result.message}}</div>
                  <v-btn outlined color="primary" @click="tryAgain()">Try Again</v-btn>
                  <v-row align="center" justify="center">
                    <v-col cols="12">

                    </v-col>
                  </v-row>
                </div>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import {MitEventBus} from '../../main.js';
  import MitLoading from '../../components/MitLoading.vue';
  import MitKeySpaces from '../../components/keys/MitKeySpaces.vue';

  import MitKeysService from '../../services/MitKeysService.js';
  import MitBorrowService from '../../services/MitBorrowService.js';
  import MitCSAILUsersService from '../../services/MitCSAILUsersService.js';
  import MitSpacesService from '../../services/MitSpacesService.js';

  export default {
    name: 'MitBorrowKeyPage',
    components: {
      MitLoading,
      MitKeySpaces
    },
    data: function() {
      return {
        valid: true,
        select: null,
        wizard:{
          step:1,//default step
          complete:false,
          loading:false,
          formData:
          {
              usersloading:false,
              userSearchTerm:'', //used by the user search as it searches for the typed text
              selectedUser:'', //keeps track of when a user is actually selected
              selectedReturnList:null,
              selectedBorrowedList:null,
              borrowedList:[],
              returnList:[]
          },
          result:{
            success:false,
            message:''
          }
        },
        userList: [],
      }
    },
    mounted() {
    },
    computed: {
        userSearch: {
          get () {
            return this.wizard.formData.userSearchTerm
          },

          set (searchInput) {
            if (this.wizard.formData.userSearchTerm !== searchInput) {
              this.wizard.formData.userSearchTerm = searchInput
              this.getCsailUsers(this.wizard.formData.userSearchTerm);
            }
          }
        }
    },
    methods: {
      userSelectedEvent(event){
        this.getBorrowedKeysForUser(event.id);
      },
      getBorrowedKeysForUser(userId){
        if(typeof (userId) !== 'undefined' || userId !== null || userId.length > 0 ){
          MitBorrowService.requestGetBorrowedKeysByOwnerId(userId)
            .then((data) => {
              this.wizard.formData.borrowedList = data;
            })
            .catch((error) => {
              console.log('An error occurred trying to get keys list', error);
            });
        }
      },
      getCsailUsers(searchterm){
        this.wizard.formData.usersloading = true;
        MitCSAILUsersService.requestGetUsers(searchterm)
          .then((data) => {
            this.userList = data.users;
            this.wizard.formData.usersloading = false;
          })
          .catch((error) => {
            this.userList = [];
            this.wizard.formData.usersloading = false;
          });
      },
      addToReturnedKeys(){

        let key = this.wizard.formData.borrowedList.splice(this.wizard.formData.selectedBorrowedList, 1);//return the items spliced are returned as an array.

        key[0].uiIndex = this.wizard.formData.selectedBorrowedList;
        this.wizard.formData.returnList.push(key[0]);
      },
      removeFromReturnedKeys(item){
        let key = this.wizard.formData.returnList.splice(this.wizard.formData.selectedReturnList, 1);
        this.wizard.formData.borrowedList.splice(key[0].uiIndex, 0, key[0]);
        delete key[0].uiIndex;
      },
      wizardComplete(){
        this.wizard.complete = true;
        this.wizard.loading = true;

        let ids = [];

        for(let x = 0; x < this.wizard.formData.returnList.length; x++){
          ids.push(this.wizard.formData.returnList[x].id);
        }

        MitBorrowService.requestReturnKeys(ids)
        // this.borrowKeys(this.wizard.formData.selectedUser.id, this.wizard.formData.borrowKeys)
          .then((data) => {
             this.wizard.loading = false;
             this.wizard.result.success = true;
          })
          .catch((error) => {
            this.wizard.loading = false;
            this.wizard.result.message = 'An error occurred trying to borrow keys.';
            console.log('An error occurred trying to get keys list', error);
          });
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
  .wizard-actions {
    padding-top: 20px;
  }
  .v-stepper__header {
    box-shadow: none;
  }
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
